import { useError } from 'react-use';

import { fetchListDependentsQuery } from 'api/queries';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import {
  ListReferencesQueryRequest,
  ListReferencesQueryResponse,
  ListReferenceSortableProperty,
} from '../../types';
import { useLazyGraphql } from 'utils/hooks/useLazyGraphql';

type QueryConfig = {
  currentPage?: number;
  listId: number | undefined;
  pageSize?: number;
  sortDirection?: SORT_DIRECTIONS;
  sortedProperty?: ListReferenceSortableProperty;
};

export const useListReferencesQuery = (config: QueryConfig) => {
  const dispatchError = useError();
  const {
    currentPage = 1,
    listId,
    pageSize = 10,
    sortDirection = SORT_DIRECTIONS.DESCENDING,
    sortedProperty = ListReferenceSortableProperty.name,
  } = config;
  const queryParams: ListReferencesQueryRequest = {
    filterInfo: { listId: listId as number },
    pagination: { limit: pageSize, offset: (currentPage - 1) * pageSize },
    sort: {
      sortBy: sortedProperty,
      sortDirection,
    },
  };
  const queryOptions = {
    notifyOnNetworkStatusChange: true,
    onError: dispatchError,
    skip: !listId,
    variables: {
      ...queryParams,
    },
  };
  const { data, isLoading, fetch, error } = useLazyGraphql<ListReferencesQueryResponse>(
    fetchListDependentsQuery,
    queryOptions,
  );

  return {
    hasError: !!error,
    isLoading,
    fetch,
    results: data?.findListUsage.results ?? [],
    totalCount: data?.findListUsage.info.count ?? 0,
  };
};
